import { useQuery } from "@apollo/client";
import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { paths } from "../../path";
import { GET_CURRENT_SEASON } from "../../query/StandingQueries";
import bp from "../../styles/breakpoint";
import Logo from "../Icon/Logo";
import CustomTooltip from "../Interface/Tooltip";
import { RootContext } from "../RootContext";
import ChangeLanguage from "./ChangeLanguage";
import Hamburger from "./Hamburger";
import Menu from "./Menu";

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  text-align: right;
  margin-right: 1em;

  @media screen and (max-width: ${bp.md}) {
    display: none;
  }
`;

const FixedPart = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${bp.md}) {
    position: absolute;
    top: 1.5rem;
    right: 1rem;
  }

  & > * {
    &:first-child {
      margin-right: 1rem;
    }
  }
`;

const SeasonBadge = styled.div`
  position: absolute;
  bottom: 0.1em;
  right: 0.1em;
  background: linear-gradient(120deg, #ffb347 0%, #ff7e00 60%, #ffe259 100%);
  color: #fff;
  border-radius: 999px;
  padding: 0.1em 0.7em 0.1em 0.6em;
  font-size: 0.72em;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  z-index: 2;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 2px #b71c1c22;
  white-space: nowrap;
  cursor: pointer;
  background-size: 200% 200%;
  transition: background-position 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-position: 100% 0;
    transition: background-position 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

const LogoContainer = styled.div`
  position: relative;
  display: inline-block;
`;

type HeaderProps = {
  hasMigration?: boolean;
};

const Header: FC<HeaderProps> = React.memo(({ hasMigration = false }) => {
  const { user } = useContext(RootContext);
  const { t } = useTranslation();
  const { data } = useQuery(GET_CURRENT_SEASON);
  return (
    <>
      {!hasMigration && <Hamburger user={user} />}
      <LogoContainer>
        <Logo
          alt={t("t:EnefelPresentation", "__EnefelPresentation")}
          link={paths.index}
          img={"logo.svg"}
          width={"80px"}
          height={"80px"}
        />
        {data?.currentSeason?.id && (
          <CustomTooltip
            title={t("t:seasonTooltip", { id: data.currentSeason.id })}
            placement="bottom"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [100, -10],
                  },
                },
              ],
            }}
          >
            <span>
              <SeasonBadge>{data.currentSeason.id}</SeasonBadge>
            </span>
          </CustomTooltip>
        )}
      </LogoContainer>
      {!hasMigration && (
        <Actions>
          <Menu user={user} />
        </Actions>
      )}
      <FixedPart>
        <ChangeLanguage />
      </FixedPart>
    </>
  );
});
export default Header;
